import React from "react";

const Pagination = (props) => {
  const handleNextBtn = () => {
    props.setPage(props.page + 1);

    if (props.page + 1 > props.maxPageNumberLimit) {
      props.setMaxPageNumberLimit(
        props.maxPageNumberLimit + props.pageNumberLimit
      );
      props.setMinPageNumberLimit(
        props.minPageNumberLimit + props.pageNumberLimit
      );
    }
  };

  const handlePageNumberClick = (e) => {
    props.setPage(Number(e.target.textContent));
    // Router.push("#top");
  };

  // console.log([...Array(Math.max(0, pages - 1))].length - pages + 1);

  const handlePrevBtn = () => {
    props.setPage(props.page - 1);
    // console.log(page);
    // Router.push("#top");

    if ((props.page - 1) % props.pageNumberLimit === 0) {
      props.setMaxPageNumberLimit(
        props.maxPageNumberLimit - props.pageNumberLimit
      );
      props.setMinPageNumberLimit(
        props.minPageNumberLimit - props.pageNumberLimit
      );
    }
  };

  const allPageNumbers = [];
  for (
    let i = 0;
    i <= Math.ceil(props.data?.length / props.itemsPerPage);
    i++
  ) {
    allPageNumbers.push(i);
  }

  return (
    <div className="text-right py-4 px-12">
      <div className="flex items-center justify-end">
        <button
          type="button"
          onClick={handlePrevBtn}
          disabled={props.page === allPageNumbers[0] + 1 ? true : false}
          className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {allPageNumbers.map((value, index) => {
          if (
            value < props.maxPageNumberLimit + 1 &&
            value > props.minPageNumberLimit
          ) {
            return (
              <button
                key={index}
                type="button"
                onClick={(e) => handlePageNumberClick(e)}
                className={
                  props.page === value
                    ? " mx-1 py-1.5 px-3 rounded text-sm bg-[#FF6A3A] text-white"
                    : "bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-3 rounded text-sm hover:bg-[#FF6A3A] hover:text-white"
                }
              >
                {value}
              </button>
            );
          }
        })}

        <button
          onClick={handleNextBtn}
          disabled={
            props.page === allPageNumbers[allPageNumbers.length - 1] ||
            allPageNumbers[allPageNumbers.length - 1] === 0
              ? true
              : false
          }
          className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
